<template>
  <header
    class="app-layout-header"
    :class="{ fixed, 'negative-radius': negativeRadius }"
  >
    <slot />
  </header>
</template>

<script>
export default {
  name: 'AppLayoutHeader',

  props: {
    fixed: {
      type: Boolean,
      default: false,
    },

    negativeRadius: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;

.app-layout-header {
  width: 100%;
  z-index: 1;
  position: relative;

  // & + :deep(.app-layout-content) {
  //   margin-top: -#{$defaultPadding};
  // }

  &.negative-radius {
    border-radius: 0;
    padding-bottom: $defaultPadding + $defaultBorderRadius;

    &::after {
      position: absolute;
      content: '';
      bottom: 0;
      left: 0;
      right: 0;
      height: $defaultBorderRadius;
      background-color: #fff;
      border-radius: $defaultBorderRadius $defaultBorderRadius 0 0;
    }
  }

  &.fixed {
    position: sticky;
  }

  :deep(> div > .app-card),
  :deep(> .app-card) {
    padding-bottom: $defaultPadding * 2 !important;

    &.no-padding {
      padding-bottom: $defaultPadding * 1 !important;
    }

    &:first-child {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    &:last-child {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
}
</style>
